<template>
  <div class="page">
    <div v-if="!ready">Loading data...</div>
    <table v-else>
      <thead>
      <tr>
        <th>Garden</th>
        <th></th>
        <th></th>
        <th>Name</th>
        <th>Layer</th>
        <th>Plantation date</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="mapPlant in mapPlants" :key="mapPlant.id">
        <td>{{ mapPlantGardenName(mapPlant) }}</td>
        <td><img :src="mapPlantPictureType(mapPlant)" alt=""></td>
        <td><img :src="mapPlantPicture(mapPlant)" alt=""></td>
        <td>{{ mapPlantName(mapPlant) }}</td>
        <td>{{ mapPlantLayer(mapPlant) }}</td>
        <td>{{ mapPlant.plantationDate | niceDate }}</td>
        <td>
          <button @click="trash(mapPlant.id)"><img src="@/assets/ui/action_trash.svg" alt="Trash"></button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'Overview',
  props: {
    visibleLayers: { type: Array, required: true },
  },
  data () {
    return {
      ready: false,
    }
  },
  computed: {
    maps () { return this.$store.getters.maps },
    mapPlants () {
      const mapId = parseInt(this.$route.params.mapId, 10)
      return this.$store.getters.mapPlants
        .filter(p => p.mapId === mapId)
        .filter(p => this.visiblePlantsIds.indexOf(p.plantId) > 1)
    },
    layers () { return this.$store.getters.layers },
    plants () { return this.$store.getters.plants },
    visiblePlantsIds () { return this.plants.filter((p) => this.visibleLayers.indexOf(p.layerId) > -1).map((p) => p.id) },
  },
  methods: {
    mapPlantName (mapPlant) {
      const plantName = this.plantFromMapPlant(mapPlant).name
      return mapPlant.name ? `${mapPlant.name} (${plantName})` : plantName
    },
    mapPlantLayer (mapPlant) {
      return this.layerFromPlant(this.plantFromMapPlant(mapPlant)).name
    },
    mapPlantPicture (mapPlant) {
      return this.plantFromMapPlant(mapPlant).getPicturePath()
    },
    mapPlantGardenName (mapPlant) {
      return this.mapFromMapPlant(mapPlant).name
    },
    /**
     * @param plant {Plant}
     * @returns {PlantationLayer}
     */
    layerFromPlant (plant) { return this.layers.find(l => l.id === plant.layerId) },
    /**
     * @param mapPlant {MapPlant}
     * @returns {Plant}
     */
    plantFromMapPlant (mapPlant) { return this.plants.find(p => p.id === mapPlant.plantId) },
    mapFromMapPlant (mapPlant) { return this.maps.find(p => p.id === mapPlant.mapId) },
    /**
     * @param mapPlant {MapPlant}
     */
    mapPlantPictureType (mapPlant) {
      const type = mapPlant.getType().toLowerCase()
      return `ui/${type}.svg`
    },
    trash (mapPlant) {
      this.$store.dispatch('deleteMapPlant', mapPlant)
    },
  },

  created () {
    // Reload data from server
    Promise.all([
      this.$store.dispatch('loadMapPlants'),
      this.$store.dispatch('loadMaps'),
      this.$store.dispatch('loadLayers'),
      this.$store.dispatch('loadPlants'),
    ])
      .then(() => { this.ready = true })
      .catch((error) => { console.log('Created:', error) })
  },

  filters: {
    niceDate (date) {
      return new Intl.DateTimeFormat('fr', {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
      }).format(date)
    },
  },
}
</script>
